import React from 'react';
import PropTypes from 'prop-types';

import MapMarker from '@mdi/svg/svg/map-marker.svg';
import CircleSmall from '@mdi/svg/svg/circle-small.svg';

import { collectEmployerClick, collectOfferClicks } from 'src/utils/analytics/applyTo';
import 'src/components/ApplyTo/Offers.scss';


const Offers = ({
  employerName, employerId, index, list, allOffersUrl, offersCount
}) => (
  <div styleName="offers">
    <ul styleName="offers__list">
      {
        list.map((offer, offerIndex) => {
          const { title, url, location } = offer;

          return (
            <li key={ `${url + offerIndex}` } styleName="offers__list-item">
              <a
                href={ url }
                onClick={ event => collectOfferClicks(event, {
                  offer,
                  employerName,
                  index: offerIndex
                }, url) }
                styleName="offers__link"
                title={ title }
              >
                <div styleName="offers__box">
                  <div styleName="offers__name">{ title }</div>
                  <div styleName="offers__location">
                    <MapMarker styleName="offers__location-marker" viewBox="0 0 24 24" />
                    {location}
                  </div>
                </div>
              </a>
            </li>
          );
        })}
    </ul>
    <a
      href={ allOffersUrl }
      onClick={ event => collectEmployerClick(event, {
        allOffersUrl,
        employerName,
        employerId,
        index
      }, allOffersUrl)
       }
      styleName="offers__link offers__link--footer"
    >


      Wszystkie oferty
      <CircleSmall styleName="offers__count" viewBox="0 0 24 24" />
      {offersCount}
    </a>
  </div>
);

Offers.propTypes = {
  allOffersUrl: PropTypes.string.isRequired,
  employerId: PropTypes.number.isRequired,
  employerName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({
    categories: PropTypes.string,
    commonOfferLocations: PropTypes.string,
    location: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string
  })).isRequired,
  offersCount: PropTypes.number.isRequired
};


export default Offers;
